import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const tooltipContainerCss = "t10thg8s";
export const TooltipContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(tooltipContainerCss, props.className)} />;
});
const tooltipIsPhoneCss = "thtmg2i";
const tooltipCss = "tkq5jh";
export const Tooltip = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(tooltipCss, {
    [tooltipIsPhoneCss]: isPhone
  }, props.className)} />;
});
const emailsWrapperCss = "ebwcybb";
export const EmailsWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(emailsWrapperCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");